import { PIXEL_NAME, TICK_TIME } from "../../utils/constants";
import { Interactive } from "../objects";
import UI from "../UI";
import LevelBase from "./levelBase";
import { translate } from "../../utils/localization";
import template from "lodash.template";

class levelGoalKit extends LevelBase {
  constructor() {
    super()

    this.goalCheckPoint = null
  }

  async connectToScene(scene) {
    await super.connectToScene(scene);

    this.destroyBlock = () => null;
    if(this.unfinished) {

      // Adds interactive tile before the dwarf before the angel before the exit :P
      const intElement = new Interactive(PIXEL_NAME.INTERACTION, this);
      intElement.order = 99;
      intElement.ephemeral = false;
      const x = this.exit.position.x - 4
      const y = this.exit.position.y
      this.interactiveElements[`${x}-${y}`] = intElement;
      intElement.setPosition({ x, y });
      this.goalCheckPoint = intElement
      console.log(this.goalCheckPoint);
      // --
    } else {
      // ============
      // removes NPCs
      // ============
      this.follower?.alien?.destroy();
      this.follower = null;
      this.replaceByEmpty(this.leader);
      this.leader.alien.destroy();
      this.leader = null;
    }
  }

  onInteractWith(el ){
    super.onInteractWith(el)

    if (el === this.goalCheckPoint && this.unfinished) {
      if(this.leader.position.x !== this.goalCheckPoint.position.x + 1) {
        this.showDialogAngel();
      } else if (this.collectedDiamonds < this.diamondsGoal) {
        this.showDialogGoal();
      } else {
        this.moveToExit()
        this.interactiveElements[`${el.position.x}-${el.position.y}`] = null
      }
    }
  }

  showDialogAngel() {

  }
  showDialogGoal() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "Doc"],
      conversation: [
        {
          who: "closeUp_Dwarf",
          text: [
            template(translate("levels.goal_dialog.dwarf_say_1"))({
              GOAL: this.diamondsGoal,
              NUM: this.collectedDiamonds,
            }),
          ],
        },
      ],
    });
  }

  async moveToExit() {
    this.player.disconnect();
    this.dwarfRun = true;
    this.leader.leadingPath = [
      { x: this.leader.position.x + 1, y: this.leader.position.y },
      { x: this.leader.position.x + 1, y: this.leader.position.y },
      { x: this.leader.position.x + 2, y: this.leader.position.y },
      { x: this.leader.position.x + 2, y: this.leader.position.y },
      { x: this.leader.position.x + 3, y: this.leader.position.y },
      { x: this.leader.position.x + 3, y: this.leader.position.y },
    ];
    this.moveDwarfToExit();

    // anim angel dismiss
    this.scene.tweens.add({
      targets: this.exit.block.alien,
      x: UI.tileToScreen(this.exit.position.x),
      duration: TICK_TIME * 2,
      onComplete: async () => {
        super.destroyBlock()
        // auto pilot off
        await this.awaitTicks(8)
        this.player.reconnect();
      },
    });
  }

  moveDwarfToExit() {
    // hack to auto move dwarf
    if (this.dwarfRun) {
      if (this.leader.leadingPath.length !== 0) {
        this.onNextTick(() => {
          this.leader.onPlayerMoves(this.leader.position);
          this.moveDwarfToExit();
        });
      } else {
        this.dwarfRun = false;
        this.replaceByEmpty(this.leader);
        this.leader = null;
      }
    }
  }
}
export default levelGoalKit;